import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface ISaveSignatureOrderService {
  orderId: string
  signature: string
}

export const saveSignatureOrderService = async ({
  orderId,
  signature,
}: ISaveSignatureOrderService) => {
  const { data } = await api.post<ResponseAPI>(
    `assinatura/${orderId}`,
    signature,
  )

  return data
}
